module.exports = __webpack_public_path__ + "img/gccc-overview.ebc5660e.jpg";